// extracted by mini-css-extract-plugin
export var bullet = "_mr-q";
export var bulletText = "_mr-p";
export var bullets = "_mr-k";
export var callout = "_mr-g";
export var calloutBody = "_mr-i";
export var calloutLabel = "_mr-h";
export var checkIcon = "_mr-m";
export var checkList = "_mr-j";
export var checkSvg = "_mr-n";
export var checkText = "_mr-o";
export var fieldCard = "_mr-1";
export var fieldDescription = "_mr-5";
export var fieldHeader = "_mr-3";
export var fieldTitle = "_mr-4";
export var finalNote = "_mr-s";
export var flow = "_mr-x";
export var flowArrow = "_mr-v";
export var flowStep = "_mr-u";
export var helperText = "_mr-r";
export var inlineTitle = "_mr-t";
export var listItem = "_mr-l";
export var noteBody = "_mr-8";
export var noteBodyText = "_mr-9";
export var noteCard = "_mr-2";
export var noteIcon = "_mr-6";
export var noteTitle = "_mr-7";
export var productChoices = "_mr-w";
export var radioDot = "_mr-d";
export var radioDotSelected = "_mr-e";
export var radioDotSvg = "_mr-f";
export var selectableCard = "_mr-b";
export var selectableCardSelected = "_mr-c";
export var strongText = "_mr-a";
export var subHeading = "_mr-0";